'use client'

import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface TemplateProps {
    children: ReactNode
}

const pageVariants = {
    initial: { opacity: 1 },
    in: { opacity: 1 }
}

const pageTransition = {
    type: 'tween',
    ease: [0.22, 1, 0.36, 1],
    duration: 0.25
}

export default function Template({ children }: TemplateProps) {
    return (
        // Keep this wrapper free of `transform` and `will-change: transform`.
        // Either one establishes a containing block for position:fixed
        // descendants, which re-bases drag-and-drop lifts (e.g. the in-person
        // visit provider reorder list) away from the viewport and offsets the
        // dragged row from the cursor.
        <motion.div
            initial="initial"
            animate="in"
            variants={pageVariants}
            transition={pageTransition}
        >
            {children}
        </motion.div>
    )
} 